import { useCallback, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { handleToast } from "../../../utils/functions";

import client from "../../client";
import handleApiError from "../../../hooks/handleApiError";

export default function useAddStudentToClass() {
  const { classId, schoolId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const request = useCallback(
    async (payload) => {
      setLoading(true);

      try {
        const { data } = await client.post(
          `/classes/v2/${classId}/students/new`,
          payload
        );

        setLoading(false);
        handleToast(data?.message);

        if (data?.success) {
          navigate(`/${schoolId}/classes/${classId}`);
        }
      } catch (error) {
        setLoading(false);
        handleApiError(error);
      }
    },
    [classId, schoolId, navigate]
  );

  return [request, loading];
}
